/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import Dropdown, { DropdownProps } from '../Dropdown'
import classNames from 'classnames'

// Type definition
export type NavDropdownProps = DropdownProps & {
    /**
     * @ignore
     */
    className?: string
    /**
     * Replace the default component tag by the one specified. Can be:
     */
    tag?: React.ElementType
    /**
     * Replace or remove a className from the component.
     * See example <a href="https://www.npmjs.com/package/map-to-css-modules" target="_blank">here</a>.
     */
    cssModule?: object

    /** Specified node element will be passed as children of `<DropdownItem />` component. */
    children: React.ReactNode
    /** Call specified function when toggle action triggered. */
    toggle: () => void
    /** Toggles isOpen CSS style. */
    isOpen: boolean
}

const NavDropdown: React.FC<NavDropdownProps> = ({ tag: Tag = 'li', ...props }) => {
    const { className, ...attributes } = props

    const classes = classNames(className, 'nav-item')

    return <Dropdown {...attributes} tag={Tag} className={classes} />
}
NavDropdown.displayName = 'NavDropdown:Dropdown'

/** @component */
export default NavDropdown
